import { render } from "./PersonLight.vue?vue&type=template&id=1c34fb47&scoped=true"
import script from "./PersonLight.vue?vue&type=script&lang=js"
export * from "./PersonLight.vue?vue&type=script&lang=js"

import "./PersonLight.vue?vue&type=style&index=0&id=1c34fb47&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c34fb47"]])

export default __exports__